// extracted by mini-css-extract-plugin
export default {"striped":"ieNlAzcwizNv9wqyqSA5"};